import React, { useCallback, useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const { login, isAuthenticated, initializing } = useAuth();
  const location = useLocation();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState(() => location.state?.errorMessage || null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.state?.errorMessage) {
      setError(location.state.errorMessage);
    }
  }, [location.state?.errorMessage]);

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      setLoading(true);
      setError(null);
      try {
        if (!form.username || !form.password) {
          throw new Error('Email and password are required.');
        }
        await login(form);
      } catch (err) {
        const message =
          err?.response?.data?.detail?.message || err?.message || 'Login failed.';
        setError(message);
      } finally {
        setLoading(false);
      }
    },
    [form, login]
  );

  if (!initializing && isAuthenticated) {
    const redirectTo = location.state?.from?.pathname || '/instructions';
    return <Redirect to={redirectTo} />;
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Candidate Login</h1>
        <p>Enter your credentials to access the assessment portal.</p>
        {error && <div className="auth-error">{error}</div>}
        <form onSubmit={handleSubmit} className="auth-form">
          <label htmlFor="username">Email</label>
          <input
            id="username"
            name="username"
            type="email"
            value={form.username}
            onChange={handleChange}
            autoComplete="email"
            required
          />

          <label htmlFor="password">Password</label>
          <input
            id="password"
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            autoComplete="current-password"
            required
          />

          <button type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
